import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { TotalBalanceDisclosure } from './BalanceBar';
import { workplaceRetirementAccountsUrl } from 'services/Externals';
import { NON_BREAKING_SPACE } from 'services/Formats';
import { FormattedDate } from '../../../shared/Text/Text';
import { retailTracEnabled } from 'services/FeatureFlags';
import { externalAuthorizationTracPath } from 'services/ExternalAuthorizationURLBuilder';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';

const AsOfDate = ({
  asOfDate,
  hasPendingTransactions,
  hasWprAccounts,
  is529Only,
  hasRetailTracAccounts,
  hasWorkplaceAccounts
}) => {

    const RetailTracLink = () => (
        <a
            href={externalAuthorizationTracPath}
            target="_blank"
            rel="noreferrer">
            T. Rowe Price Small Business Retirement Plan
        </a>
    );

    const WorkplaceLink = () => (
        <a
            href={workplaceRetirementAccountsUrl}
            target="_blank"
            rel="noreferrer">
            T. Rowe Price Workplace Retirement
        </a>
    );

    const WorkplacePendingLink = () => (
        <a href={workplaceRetirementAccountsUrl} className="pending-link">
            T. Rowe Price Workplace Retirement
        </a>
    )

    const RetailTracLinkWithPermissions = WithUserPermissions(RetailTracLink)

    const WorkPlaceLinkWithPermissions = WithUserPermissions(WorkplaceLink)

    const WorkPlacePendingLinkWithPermissions = WithUserPermissions(WorkplacePendingLink)

  const renderSuffix = () => {
    switch (true) {
      case retailTracEnabled() &&
        hasPendingTransactions &&
        hasRetailTracAccounts &&
        hasWorkplaceAccounts &&
        is529Only:
        return (
          <Fragment>
            {NON_BREAKING_SPACE}and does not include your
            {NON_BREAKING_SPACE}
            <div>
                <WorkPlaceLinkWithPermissions shouldDisable/>
              {NON_BREAKING_SPACE}or
              {NON_BREAKING_SPACE}
                <RetailTracLinkWithPermissions shouldDisable/>
            </div>
            {NON_BREAKING_SPACE}accounts or any
            {NON_BREAKING_SPACE}
            <Link to="/transactions" className="pending-link">
              pending transactions
            </Link>
            . Unless otherwise indicated
            <TotalBalanceDisclosure is529Only={is529Only} />
          </Fragment>
        );
      case retailTracEnabled() &&
        !hasPendingTransactions &&
        hasRetailTracAccounts &&
        hasWorkplaceAccounts &&
        is529Only:
        return (
          <Fragment>
            {NON_BREAKING_SPACE}and does not include your
            {NON_BREAKING_SPACE}
            <div>
                <WorkPlaceLinkWithPermissions shouldDisable/>
              {NON_BREAKING_SPACE}or
              {NON_BREAKING_SPACE}
                <RetailTracLinkWithPermissions shouldDisable/>
            </div>
            {NON_BREAKING_SPACE}accounts.
            {NON_BREAKING_SPACE}Unless otherwise indicated
            <TotalBalanceDisclosure is529Only={is529Only} />
          </Fragment>
        );
      case retailTracEnabled() &&
        hasPendingTransactions &&
        hasRetailTracAccounts &&
        is529Only:
        return (
          <Fragment>
            {NON_BREAKING_SPACE}and does not include your
            {NON_BREAKING_SPACE}
            <div>
                <RetailTracLinkWithPermissions shouldDisable/>
            </div>
            {NON_BREAKING_SPACE}accounts or any
            {NON_BREAKING_SPACE}
            <Link to="/transactions" className="pending-link">
              pending transactions
            </Link>
            . Unless otherwise indicated
            <TotalBalanceDisclosure is529Only={is529Only} />
          </Fragment>
        );
      case retailTracEnabled() &&
        hasPendingTransactions &&
        hasWorkplaceAccounts &&
        is529Only:
        return (
          <Fragment>
            {NON_BREAKING_SPACE}and does not include your
            {NON_BREAKING_SPACE}
            <div>
                <WorkPlaceLinkWithPermissions shouldDisable/>
            </div>
            {NON_BREAKING_SPACE}accounts or any
            {NON_BREAKING_SPACE}
            <Link to="/transactions" className="pending-link">
              pending transactions
            </Link>
           . Unless otherwise indicated
            <TotalBalanceDisclosure is529Only={is529Only} />
          </Fragment>
        );
      case retailTracEnabled() &&
        !hasPendingTransactions &&
        hasRetailTracAccounts &&
        is529Only:
        return (
          <Fragment>
            {NON_BREAKING_SPACE}and does not include your
            {NON_BREAKING_SPACE}
            <div>
                <RetailTracLinkWithPermissions shouldDisable/>
            </div>
            {NON_BREAKING_SPACE}accounts.
            {NON_BREAKING_SPACE}Unless otherwise indicated
            <TotalBalanceDisclosure is529Only={is529Only} />
          </Fragment>
        );
      case retailTracEnabled() &&
        !hasPendingTransactions &&
        hasWorkplaceAccounts &&
        is529Only:
        return (
          <Fragment>
            {NON_BREAKING_SPACE}and does not include your
            {NON_BREAKING_SPACE}
            <div>
                <WorkPlaceLinkWithPermissions shouldDisable/>
            </div>
            {NON_BREAKING_SPACE}accounts.
            {NON_BREAKING_SPACE}Unless otherwise indicated
            <TotalBalanceDisclosure is529Only={is529Only} />
          </Fragment>
        );
      case hasPendingTransactions && hasWprAccounts && is529Only:
        return (
          <Fragment>
            {NON_BREAKING_SPACE}and does not include your
            {NON_BREAKING_SPACE}
            <WorkPlacePendingLinkWithPermissions shouldDisable/>
            {NON_BREAKING_SPACE}accounts or any
            {NON_BREAKING_SPACE}
            <Link to="/transactions" className="pending-link">
              pending transactions
            </Link>
            . Unless otherwise indicated
            <TotalBalanceDisclosure is529Only={is529Only} />
          </Fragment>
        );
      case !hasPendingTransactions && hasWprAccounts && is529Only:
        return (
          <Fragment>
            {NON_BREAKING_SPACE}and does not include your
            {NON_BREAKING_SPACE}
            <WorkPlacePendingLinkWithPermissions shouldDisable/>
            {NON_BREAKING_SPACE}accounts.
            {NON_BREAKING_SPACE}Unless otherwise indicated
            <TotalBalanceDisclosure is529Only={is529Only} />
          </Fragment>
        );
      case hasPendingTransactions && !is529Only:
      case hasPendingTransactions && !hasWprAccounts && is529Only:
        return (
          <Fragment>
            {NON_BREAKING_SPACE}and does not reflect any
            {NON_BREAKING_SPACE}
            <Link to="/transactions" className="pending-link">
              pending transactions
            </Link>
            . Unless otherwise indicated*
            <TotalBalanceDisclosure is529Only={is529Only} />
          </Fragment>
        );
      default:
        return (
          <Fragment>
            {NON_BREAKING_SPACE}unless otherwise indicated
            <TotalBalanceDisclosure is529Only={is529Only} />
          </Fragment>
        );
    }
  };

  return (
    <div className="balance-bar-as-of-container">
      <div className="pending-copy">
        All data as of{NON_BREAKING_SPACE}
        <FormattedDate className="formatted-date">{asOfDate}</FormattedDate>
        {renderSuffix()}
      </div>
    </div>
  );
};

export default AsOfDate;
